export default __webpack_public_path__ + "static/media/literature.ec83a44c.jpg";